import React, { useState, useEffect } from 'react';
import appSettings from '../../config/appSettings';
import styles from './CountdownOverlay.module.css';
import { useGameState } from '../../context/GameStateContext';

const CountdownOverlay = ({ onCountdownComplete, onComplete }) => {
  // Support both prop names for backward compatibility
  const handleComplete = onCountdownComplete || onComplete;
  const [count, setCount] = useState(appSettings.countdownDuration);
  const [isAnimating, setIsAnimating] = useState(true);
  
  // Get puzzle data from GameStateContext
  const { gameData } = useGameState();
  
  // Effect to handle the countdown
  useEffect(() => {
    if (count > 0) {
      const timer = setTimeout(() => {
        setCount(prevCount => prevCount - 1);
      }, 1000); 
      
      return () => clearTimeout(timer);
    } else {
      handleComplete(); 
    }
  }, [count, handleComplete]);
  
  // Create a blank grid based on puzzle size
  const renderBlankGrid = () => {
    if (!gameData.puzzle || !gameData.puzzle.size) {
      throw new Error('CountdownOverlay: puzzle.size is required but not provided');
    }
    
    const cells = [];
    const gridSize = gameData.puzzle.size;
    
    for (let i = 0; i < gridSize * gridSize; i++) {
      cells.push(
        <div 
          key={`cell-${i}`} 
          className={styles.blankCell}
        />
      );
    }
    
    return (
      <div 
        className={styles.blankGrid}
        style={{
          gridTemplateColumns: `repeat(${gridSize}, 1fr)`,
          gridTemplateRows: `repeat(${gridSize}, 1fr)`
        }}
      >
        {cells}
      </div>
    );
  };
  
  return (
    <div className={styles.countdownOverlay}>
      <div className={styles.countdownContainer}>
        {renderBlankGrid()}
        
        <div className={styles.countdownNumberContainer}>
          {count > 0 ? (
            <div className={`${styles.countdownNumber} ${isAnimating ? styles.animateIn : styles.animateOut}`}>
              {count}
            </div>
          ) : (
            <div className={`${styles.countdownGo} ${styles.animateIn}`}>
              GO!
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CountdownOverlay;
